<template>
    <v-col cols="12" md="6">
            <v-card class="mx-auto" tile>
                <v-card-title>{{ type }}s</v-card-title>
        
                <v-data-table
                :headers="headers"
                :items="filteredItems"
                disable-pagination
                :hide-default-footer="true"

                >
                <template v-slot:[`item.name`]="{ item }">
                    <router-link :to="{ name: type + '-gallery' , params: { id: item[type].name.toLowerCase() }}">
                        {{ item[type].name }}
                    </router-link>
                </template>

                <template v-slot:[`item.published`]="{ item }">
                    <span v-if="objectInArray(item[type])">
                        true
                    </span>
                    <span v-else>
                        false
                    </span>
                </template>

                <template v-slot:[`item.actions`]="{ item }">
                    
                    <span v-if="objectInArray(item[type])">
                        <v-icon  @click="$emit('remove-group', type +'s', item[type].id)">mdi-image-minus</v-icon>
                    </span>
                    <span v-else>
                        <v-icon  @click="$emit('add-group', type + 's', item[type] )">mdi-image-plus</v-icon>
                    </span>
                </template>
                </v-data-table>

            </v-card>
            </v-col>
</template>

<script>
import { groupMixin } from '@/functions/mixins'

export default {
    name: "GroupEdit",
    props: ['groups', 'type', 'posts'],
    mixins: [groupMixin],
    data() {
            return {
                headers: [
                    { text: "Name", align: "start", sortable: true, value: "name" },
                    { text: "Published", align: "start", sortable: true, value: "published" },
                    { text: "Actions", value: "actions", sortable: false },
                ],
            }
    },
    methods: {
        objectInArray(obj) {
            if (this.posts.filter(e => (e.id === obj.id && e.name === obj.name)).length === 0) {
                return false
            } else {
                return true
            }
        }
    }
        
}
</script>